var React = require('react');

function CheckInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.7255 32.3303C13.6159 32.3303 12.5564 31.8482 11.7723 30.9977L1.22321 19.4956C-0.407738 17.7173 -0.407738 14.8338 1.22321 13.0555C2.85416 11.2772 5.49872 11.2772 7.12967 13.0555L14.7255 21.3376L32.8703 1.55345C34.5013 -0.224848 37.1458 -0.224848 38.7768 1.55345C40.4077 3.33175 40.4077 6.21523 38.7768 7.99353L17.6787 30.9977C16.8945 31.8527 15.8309 32.3303 14.7255 32.3303Z","fill":"#10BB73"}));
}

CheckInline.defaultProps = {"width":"40","height":"33","viewBox":"0 0 40 33","fill":"none"};

module.exports = CheckInline;

CheckInline.default = CheckInline;
